export default __webpack_public_path__ + "static/media/luca-bravo-O453M2Liufs-unsplash.42a58d64.jpg";